/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["මැ", "ම", "පා", "උ", "ද", "හ", "රෑ", "මැ"], ["මැදියම", "මධ්‍යාහ්නය", "පාන්දර", "උදේ", "දවල්", "හවස", "රෑ", "මැදියමට පසු"], u], [["මැදියම", "මධ්‍යාහ්නය", "පාන්දර", "උදේ", "දවල්", "හවස", "රෑ", "මැදියමට පසු"], u, u], ["00:00", "12:00", ["01:00", "06:00"], ["06:00", "12:00"], ["12:00", "14:00"], ["14:00", "18:00"], ["18:00", "24:00"], ["00:00", "01:00"]]];
